<nz-input-group *ngIf="recordProperty !== undefined">
  <textarea [nzAutosize]="{ minRows: 5 }" nz-input [(ngModel)]="recordProperty.ValueAsObject"
    [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged()"
    [class]="parentClass"
    [disabled]="recordProperty.ReadOnly">
	</textarea>
</nz-input-group>
